// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// import { getAuth } from "firebase/auth";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyCs2oghJ6docZ6bWLsjNuFSg-zqCQKRg-4",
//   authDomain: "wapp-solutya.firebaseapp.com",
//   projectId: "wapp-solutya",
//   storageBucket: "wapp-solutya.appspot.com",
//   messagingSenderId: "540126050092",
//   appId: "1:540126050092:web:1e56d12ba71f4246c49e89",
//   measurementId: "G-ESHW1L23D7",
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);

// const auth = getAuth(app);

// export default auth;
// // const analytics = getAnalytics(app);

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCs2oghJ6docZ6bWLsjNuFSg-zqCQKRg-4",
  authDomain: "wapp-solutya.firebaseapp.com",
  projectId: "wapp-solutya",
  storageBucket: "wapp-solutya.appspot.com",
  messagingSenderId: "540126050092",
  appId: "1:540126050092:web:1e56d12ba71f4246c49e89",
  measurementId: "G-ESHW1L23D7",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export default auth;
